<template>
  <div class="about">
    <a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=550095&Code=MioS8nnmDvccxxgvKJeahCL2NIm70u3x'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=550095&Code=MioS8nnmDvccxxgvKJeahCL2NIm70u3x' alt='' style='cursor:pointer' code='MioS8nnmDvccxxgvKJeahCL2NIm70u3x'></a>
  </div>
</template>
